<template>
  <div class="employee-index">
    <transition
      name="fade"
      mode="out-in"
      @beforeLeave="beforeLeave"
      @enter="enter"
      @afterEnter="afterEnter"
    >
      <div key="1" v-if="loader" class="white-row loader-route">
        <div class="lds-sub-ripple">
          <div></div>
          <div></div>
        </div>
      </div>
      <div v-else key="1" class="white-row">
        <!-- // Filter Area -->
        <div class="general-filters">
          <div class="col-sm-12">
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                <div class="row top-gen-heading">
                  <h1 class="global-style-heading">
                    Old Payments
                    <a
                      @click.prevent="refreshClientTable"
                      href=""
                      class="refreshData"
                      ><i class="fas fa-redo-alt"></i
                    ></a>
                  </h1>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                <form @submit.prevent="getPaymentsData(1)">
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="row">
                        <form @submit.prevent="">
                          <div class="form-group">
                            <label for="gender" class="control-label"
                              >&nbsp;</label
                            >
                            <div class="input-group">
                              <input
                                v-model="formData.search"
                                @keyup="getPaymentsData(1, 'search')"
                                type="text"
                                class="form-control"
                                placeholder="Search.."
                              />
                              <div class="input-group-append">
                                <button class="btn btn-secondary" type="button">
                                  <i class="fa fa-search"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="row">
                        <div class="form-actions">
                          <button
                            type="submit"
                            class="btn btn-primary default-global-btn"
                          >
                            Add Payments
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="horizontal-row">
          <hr />
        </div>
        <div class="emp-listing">
          <transition
            name="fade"
            mode="out-in"
            @beforeLeave="beforeLeave"
            @enter="enter"
            @afterEnter="afterEnter"
          >
            <div key="1" v-if="client_loader" class="white-row loader-route">
              <div class="lds-sub-ripple">
                <div></div>
                <div></div>
              </div>
            </div>
            <div v-else class="client-page-wrapper">
              <div class="">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Order ID</th>
                        <th>Order Date</th>
                        <th>Project Name</th>
                        <th>Client Name</th>
                        <th>Workbench Client</th>
                        <th>Email</th>
                        <th>Amount</th>
                        <th>Product</th>
                        <th>Sales</th>
                        <th>AM</th>
                        <th>Phone</th>
                        <th>Comments</th>
                        <th>Order Link</th>
                        <th>Teamwork Link</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody
                      v-if="
                        typeof payments_list.data !== 'undefined' &&
                          Object.keys(payments_list.data).length
                      "
                    >
                      <tr
                        v-for="(payment, inv_index) in payments_list.data"
                        :key="inv_index"
                        :class="payment.add_class"
                      >
                        <td>
                          {{ payment.id }}
                        </td>
                        <td>
                          {{ payment.order_id }}
                        </td>
                        <td>
                          {{ payment.order_date }}
                        </td>
                        <td>
                          {{ payment.project_name }}
                        </td>
                        <td>
                          {{ payment.client_name }}
                        </td>
                        <td v-if="payment.user_id">
                          <b>Id :</b> {{ payment.user_details.id }}<br />
                          <b>Name :</b> {{ payment.user_details.name }}<br />
                          <b>Email :</b> {{ payment.user_details.email }}<br />
                        </td>
                        <td v-else>
                          <strong>No Record Found!.</strong>
                        </td>

                        <td>
                          {{ payment.email }}
                        </td>
                        <td>
                          {{ payment.amount }}
                        </td>
                        <td>
                          {{ payment.product }}
                        </td>
                        <td>
                          {{ payment.sales }}
                        </td>
                        <td>
                          {{ payment.am }}
                        </td>
                        <td>
                          {{ payment.phone }}
                        </td>
                        <td>
                          {{ payment.comments }}
                        </td>
                        <td>
                          {{ payment.order_link }}
                        </td>
                        <td>
                          {{ payment.teamwork_link }}
                        </td>
                        <td>
                          <!-- Dropdown -->
                          <div class="header-top">
                            <dropdown>
                              <template slot="icon"
                                ><i class="fas fa-ellipsis-v"></i
                              ></template>
                              <template slot="body">
                                <ul class="list-group">
                                  <li class="list-group-item">
                                    <router-link
                                      class="invoice-icon"
                                      title="Edit!"
                                      data-placement="top"
                                      :to="{
                                        path: '/old-payments/edit/' + payment.id
                                      }"
                                      tag="a"
                                    >
                                      <p class="invoice-icon">
                                        <i class="far fa-edit"></i>
                                      </p>
                                    </router-link>
                                  </li>
                                </ul>
                              </template>
                            </dropdown>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td colspan="14">
                          <no-record-found></no-record-found>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- <div v-else class="row">
                <div class="col-sm-12">
                  <no-record-found></no-record-found>
                </div>
              </div> -->
            </div>
          </transition>

          <div class="row">
            <div class="col-sm-12">
              <pagination
                class="pagination justify-content-center"
                :data="payments_list"
                :limit="1"
                @pagination-change-page="getPaymentsData"
              ></pagination>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import norecordfound from "../../../components/no-record-found";
import Dropdown from "bp-vuejs-dropdown";
export default {
  components: {
    "no-record-found": norecordfound,
    Dropdown
  },
  data() {
    return {
      copy_url: null,
      loader: true,
      payments_list: {},
      formData: {
        search: ""
      }
    };
  },
  mounted() {
    document.title =
      "PNC Work Bench - " + this.$router.app._route.meta.pageTitle;
    this.copy_url = window.app_url + "/package-form/";
    this.getPaymentsData();
    this.loader = false;
    this.main_app_url = window.parent_app_url;
  },
  computed: {
    getActiveUserData() {
      return this.$store.state.auth;
    }
  },
  methods: {
    refreshClientTable() {
      this.getPaymentsData();
      this.loader = false;
    },
    async getPaymentsData(page = 1, action = null) {
      const $this = this;
      if (action == "search") {
        if ($this.formData.search.length < 2 && $this.formData.search != "") {
          return true;
        }
      }
      $this.client_loader = true;
      const data = $this.$store.dispatch("getHttp", {
        url:
          "old-payments?" +
          "&page=" +
          page +
          "&search=" +
          $this.formData.search +
          "&timezone=" +
          Intl.DateTimeFormat().resolvedOptions().timeZone
      });
      await data.then(function(response) {
        if (typeof response !== "undefined") {
          $this.payments_list = response.data;
        }
        $this.client_loader = false;
      });
    },
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      const { height } = getComputedStyle(element);

      element.style.height = this.prevHeight;

      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = "auto";
    }
  }
};
</script>
<style lang="scss" scoped>
.highlight-row {
  background: #fafafa;
}

.invoice-icon {
  display: inline-block;
  background: #1190ee;
  color: #fff !important;
  padding: 6px 8px;
  border-radius: 5px;
}
.remo-margin {
  margin: 0;
}
body .white-row.loader-route {
  top: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-property: height, opacity;
  transition-timing-function: ease;
  overflow: hidden;
}
.employee-index {
  .general-filters {
    .form-group {
      width: 95%;
      .input-group {
        input {
          border-radius: 3px !important;
          background: #f9f9f9;
          letter-spacing: 0.28px;
          font-size: 14px;
          padding: 3px 15px;
          color: #364460;
          border: none;
          font-weight: 200;
          height: auto;
        }
        button {
          background: #f9f9f9;
          color: #3b4c54;
          border: none;
          padding: 4px 8px;
        }
      }
    }
    .form-actions {
      width: 100%;
      button {
        width: 100%;
        margin-left: 0;
        padding: 5px 0;
      }
    }
    span.select2.select2-container.select2-container--default {
      width: 100% !important;
    }
  }
  .horizontal-row {
    padding: 30px 0 30px;
    hr {
      margin: 0;
    }
  }
  .wrap-box {
    background: #faf9f7;
    border-radius: 3px;
    padding: 0 20px;
    margin-bottom: 30px;
    .header-top {
      position: absolute;
      right: 26px;
      z-index: 100;
      top: 19px;
      .bp-dropdown__btn {
        border: none;
      }
      .bp-dropdown__body {
        padding: 0;
        background-color: #fff;
        box-shadow: 0 5px 15px -5px rgba(0, 0, 0, 0.5);
        z-index: 9999;
        border-radius: 4px;
        border: none;
        margin-top: 10px;
        .list-group {
          .list-group-item {
            border: none;
            position: relative;
            display: block;
            border-bottom: 1px solid rgba(0, 0, 0, 0.125);
            padding: 10px 20px 10px 7px;
            text-align: left;
            a {
              color: #212529;
            }
          }
        }
      }
    }
    .emp-details {
      position: relative;
      padding: 20px 0 20px 44px;
      p {
        margin: 0;
        &.user-title {
          font-size: 12px;
        }
        &.user-email {
          font-size: 12px;
        }
      }
      .vue-avatar--wrapper.mr-3 {
        width: 32px !important;
        height: 32px !important;
        position: absolute;
        top: 23px;
        left: 0;
        span {
          letter-spacing: 0.24px;
          color: #ffffff;
          font-size: 12px;
          font-weight: bold;
        }
      }
    }
    .box-brand {
      padding-bottom: 10px;
      div {
        display: inline-block;
        vertical-align: middle !important;
        width: 50%;
        &.brand-para {
          p {
            margin: 0;
          }
        }
        &.text-right {
          p {
            margin: 0;
          }
        }
      }
    }
    .projects-list {
      p {
        font-weight: bold;
      }
    }
    .footer-box {
      display: block;
      position: relative;
      width: 100%;
      padding: 12px 0;
      border-top: 1px solid rgba(0, 0, 0, 0.1);
      &:first-child {
        border-top: none;
        padding-top: 2px;
      }
      .usr-role {
        p {
          margin: 0;
          letter-spacing: 0.24px;
          color: #918a82;
          font-size: 12px;
        }
      }
      .usr-role-name {
        position: absolute;
        right: -35px;
        top: 0;
        .custom-avtr {
          display: inline-block;
          position: relative;
          &.orv-1 {
          }
          &.orv-2 {
            left: -11px;
          }
          &.orv-3 {
            left: -22px;
          }
          &.orv-4 {
            left: -34px;
          }
          .vue-avatar--wrapper {
            margin: 0 !important;
            width: 25px !important;
            height: 25px !important;
            padding: 3px 4px 0 !important;
            span {
              font-size: 11px;
            }
          }
        }
        &.empty_am {
          right: 0;
        }
      }
    }
  }
  .justify-content-center {
    margin-bottom: 0;
  }
  .table td {
    padding: 0.75rem;
    vertical-align: middle !important;
    border-top: 1px solid #dee2e6;
  }
  p.invoice-icon {
    margin-bottom: 2px;
  }
}

// Media Query Start

// Extra large devices (lg and less)
@media screen and (max-width: 1199px) {
}
// Extra large devices (md and less)
@media screen and (max-width: 991px) {
}

// Extra large devices (sm and up)
@media screen and (max-width: 767px) {
  body .top-gen-heading {
    padding-top: 10px;
    padding-bottom: 10px;
  }
}

// Extra large devices (xs and up)
@media screen and (max-width: 575px) {
  .employee-index .general-filters .form-group {
    width: 100%;
  }
}
// Extra large devices (xl, 1200px and up)
@media (min-width: 1200) {
}
</style>
